import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import { makeStyles } from '@material-ui/core'
import { isEmpty, filter, includes } from 'ramda'
import effects from 'app/effects/effects'
import { useIntl } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  endAdornment: {
    width: '100%',
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}))

const NationalitySelector = ({
  value,
  onChange,
  placeholder,
  className,
  prefer = [],
}) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()

  const [nationalities, setNationalities] = useState([])

  useEffect(() => {
    effects.apis.getNationalities().then((response) => {
      setNationalities(
        isEmpty(prefer)
          ? response.data
          : filter((item) => {
              return includes(item.countryCode, prefer)
            }, response.data),
      )
    })
  }, [])

  return (
    <Autocomplete
      options={nationalities}
      getOptionLabel={(option) =>
        `${option.nationality}(${option.countryCode})`
      }
      value={nationalities.find((g) => g.nationality === value) || null}
      className={className}
      noOptionsText={formatMessage({
        id: 'crm.form.receiveMethods.option.empty',
      })}
      onChange={(event, newValue) => {
        if (onChange) {
          onChange(newValue ? newValue.nationality : '')
        }
      }}
      renderInput={(params) => (
        <div ref={params.InputProps.ref} className="w-full">
          <SimpleInput
            id="nationality"
            placeholder={placeholder}
            endAdornment={
              <div className={classes.endAdornment}>
                {params.InputProps.endAdornment}
              </div>
            }
            size="medium"
            fullWidth
            {...params}
          />
        </div>
      )}
    />
  )
}

NationalitySelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  prefer: PropTypes.array,
}

export default NationalitySelector
